(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["md-product-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('md-product-stock')) {
    customElements.define('md-product-stock', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-md-stock-variants]').textContent);
        this.root = this.closest('[data-section-type="product-page"]') || this.closest('product-form') || this.parentElement;
        this.onChange = event => {
          if (event.target.matches('input[name="id"]')) queueMicrotask(() => this.update(event.target.value));
        };
        this.root.addEventListener('change', this.onChange);
        this.update(this.closest('form')?.querySelector('input[name="id"]')?.value);
      }
      disconnectedCallback() { this.root?.removeEventListener('change', this.onChange); }
      update(id) {
        const text = this.variants[id];
        if (!text) return;
        this.querySelector('[data-md-stock-text]').textContent = text;
        this.root.querySelectorAll('[data-availability]').forEach(node => { node.textContent = text; });
        this.toggleAttribute('data-sold-out', text.toLowerCase() === 'sold out');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["md-shop-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('md-shop-navigation')) {
    customElements.define('md-shop-navigation', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-md-shop-tab]');
          if (!button) return;
          this.querySelectorAll('[data-md-shop-tab]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
          this.querySelectorAll('[data-md-shop-pane]').forEach(pane => { pane.hidden = pane.dataset.mdShopPane !== button.dataset.mdShopTab; });
        });
        const dropdown = this.closest('.md-shop-dropdown');
        if (!dropdown) return;
        dropdown.querySelector('summary').addEventListener('click', event => {
          if (event.detail > 0) { event.preventDefault(); dropdown.open = true; }
        });
        dropdown.addEventListener('mouseenter', () => { dropdown.open = true; });
        dropdown.addEventListener('mouseleave', () => { if (!dropdown.contains(document.activeElement)) dropdown.open = false; });
        dropdown.addEventListener('focusout', event => { if (!dropdown.contains(event.relatedTarget)) dropdown.open = false; });
        dropdown.addEventListener('keydown', event => {
          if (event.key === 'Escape') { dropdown.open = false; dropdown.querySelector('summary').focus(); }
        });
        this.onOutsideClick = event => { if (!dropdown.contains(event.target)) dropdown.open = false; };
        document.addEventListener('pointerdown', this.onOutsideClick);
      }
      disconnectedCallback() { if (this.onOutsideClick) document.removeEventListener('pointerdown', this.onOutsideClick); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
